var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-stepper",
    {
      staticClass: "elevation-0",
      attrs: { vertical: "" },
      model: {
        value: _vm.step,
        callback: function ($$v) {
          _vm.step = $$v
        },
        expression: "step",
      },
    },
    [
      _c(
        "v-stepper-step",
        { attrs: { complete: !!_vm.assumedRole, step: "1" } },
        [_vm._v(" Account Credentials ")]
      ),
      _c("AuthStepBasic", {
        attrs: {
          "access-token": _vm.accessToken,
          "secret-token": _vm.secretToken,
          region: _vm.region,
          endpoint: _vm.endpoint,
          "skip-sts": _vm.skipSts,
        },
        on: {
          "update:accessToken": function ($event) {
            _vm.accessToken = $event
          },
          "update:access-token": function ($event) {
            _vm.accessToken = $event
          },
          "update:secretToken": function ($event) {
            _vm.secretToken = $event
          },
          "update:secret-token": function ($event) {
            _vm.secretToken = $event
          },
          "update:region": function ($event) {
            _vm.region = $event
          },
          "update:endpoint": function ($event) {
            _vm.endpoint = $event
          },
          "update:skipSts": function ($event) {
            _vm.skipSts = $event
          },
          "update:skip-sts": function ($event) {
            _vm.skipSts = $event
          },
          "auth-basic": _vm.handleBasic,
          "goto-mfa": _vm.handleGotoMfa,
          "show-help": function ($event) {
            _vm.showHelp = true
          },
        },
      }),
      _c(
        "v-stepper-step",
        {
          attrs: {
            complete: !!_vm.assumedRole && _vm.assumedRole.from_mfa,
            step: "2",
          },
        },
        [_vm._v(" MFA Authorization ")]
      ),
      _c("AuthStepMFA", {
        attrs: { "mfa-token": _vm.mfaToken, "mfa-serial": _vm.mfaSerial },
        on: {
          "update:mfaToken": function ($event) {
            _vm.mfaToken = $event
          },
          "update:mfa-token": function ($event) {
            _vm.mfaToken = $event
          },
          "update:mfaSerial": function ($event) {
            _vm.mfaSerial = $event
          },
          "update:mfa-serial": function ($event) {
            _vm.mfaSerial = $event
          },
          "auth-mfa": _vm.handleProceedMFA,
          "exit-mfa": _vm.handleCancelMfa,
        },
      }),
      _c("v-stepper-step", { attrs: { step: "3" } }, [
        _vm._v(" Browse Bucket "),
      ]),
      _c("FileList", {
        attrs: { auth: _vm.assumedRole, files: _vm.files },
        on: {
          "exit-list": _vm.handleExitList,
          "got-files": _vm.gotFiles,
          "load-bucket": _vm.loadBucket,
        },
      }),
      _c(
        "v-overlay",
        { attrs: { opacity: 50, absolute: "absolute", value: _vm.showHelp } },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "p",
                [
                  _c("span", [
                    _vm._v(
                      " For installation instructions and further information, check here: "
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://github.com/mitre/heimdall2#aws-s3",
                        text: "",
                        color: "info",
                        "px-0": "",
                      },
                    },
                    [
                      _c("v-icon", { attrs: { "pr-2": "" } }, [
                        _vm._v("mdi-github-circle"),
                      ]),
                      _vm._v(" S3 Configuration "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "info" },
                  on: {
                    click: function ($event) {
                      _vm.showHelp = false
                    },
                  },
                },
                [_vm._v(" Close ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }